import { getUtms } from "./utm";

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CONSENT_KEY = "2bs_consent";
const STANDARD_EVENTS = ["PageView"];

let pixelLoaded = false;

export function hasConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY) === "granted";
  } catch (e) {
    return false;
  }
}

function loadPixel() {
  if (pixelLoaded || !PIXEL_ID) return;
  const w = window;
  const n = (w.fbq = function (...args) {
    n.callMethod ? n.callMethod(...args) : n.queue.push(args);
  });
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
  n("init", PIXEL_ID);
  pixelLoaded = true;
}

export function setConsent(granted) {
  try {
    localStorage.setItem(CONSENT_KEY, granted ? "granted" : "denied");
  } catch (e) {
    /* Speicherung nicht möglich */
  }
  if (granted) loadPixel();
}

function neueEventId(name) {
  const zufall = window.crypto && window.crypto.randomUUID
    ? window.crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `${name}.${zufall}`;
}

export function track(name, { email, phone, vorname, nachname, customData } = {}) {
  if (!hasConsent() || !PIXEL_ID) return;
  loadPixel();
  const eventId = neueEventId(name);
  const methode = STANDARD_EVENTS.includes(name) ? "track" : "trackCustom";
  if (window.fbq) {
    window.fbq(methode, name, customData || {}, { eventID: eventId });
  }
  fetch(`${API}/meta/event`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      event_name: name,
      event_id: eventId,
      event_source_url: window.location.href,
      email: email || null,
      phone: phone || null,
      vorname: vorname || null,
      nachname: nachname || null,
      fbclid: getUtms().fbclid || null,
      consent: true,
      custom_data: customData || {}
    }),
    keepalive: true
  }).catch(() => {});
}